import axios from 'axios'

const serializeEvent = (rawEvent) => {
	rawEvent.venue = rawEvent.venue || {}
	const {time, name, link, venue: {name: place}} = rawEvent
	return {time, name, link, place}
}

export const fetchFutureEvents = async ({orgId}) => (await axios.get(`https://cors-anywhere.herokuapp.com/https://api.meetup.com/${orgId}/events?&page=6`)).data.splice(0, 6).map(serializeEvent)
export const fetchPastEvents = async ({orgId}) => (await axios.get(`https://cors-anywhere.herokuapp.com/https://api.meetup.com/${orgId}/events?status=past&page=3`)).data.splice(0, 3).map(serializeEvent)
